import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import gtm from '@/utils/gtm';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic: EFPic1 } = createEFPic('/media/delta2/pc/');
const { EFPic: EFPic2 } = createEFPic('/media/delta2/h5/');

const linkMap: any = {
    us: {
        link2: 'https://us.ecoflow.com/products/delta-2-portable-power-station',
        link1: 'https://www.amazon.com/dp/B0B9XB57XM?maas=maas_adg_2C9A288F5494385D94206A12D6C13C5E_afap_abs&ref_=aa_maas&tag=maas',
    },
    ca: {
        link2: 'https://ca.ecoflow.com/products/delta-2-portable-power-station',
        link1: 'https://www.amazon.ca/dp/B0BDFJH5SL?maas=maas_adg_CE6B40401E5C9F7D6367313B6CE58411_afap_abs&ref_=aa_maas&tag=maas',
    },
    eu: {
        link2: '',
        link1: '',
    },
    uk: {
        link2: 'https://uk.ecoflow.com/products/delta-2-portable-power-station',
        link1: 'https://www.amazon.co.uk/dp/B0B9B9MPX6?maas=maas_adg_E1EB7CE03178CC6C0B2A9E35FBA5BBB4_afap_abs&ref_=aa_maas&tag=maas',
    },
    de: {
        link2: 'https://de.ecoflow.com/products/delta-2-portable-power-station',
        link1: 'https://www.amazon.de/dp/B0BBLV8WJH?maas=maas_adg_383DF1850A5074B88A427BE030F4D882_afap_abs&ref_=aa_maas&tag=maas',
    },
    fr: {
        link2: 'https://fr.ecoflow.com/products/delta-2-portable-power-station',
        link1: 'http://www.amazon.fr/dp/B0BBLV8WJH?maas=maas_adg_E9917215C303080C59EF81726A8DAC5B_afap_abs&ref_=aa_maas&tag=maas',
    },
    jp: {
        link2: 'https://jp.ecoflow.com/products/delta-2-portable-power-station',
        link1: 'https://www.amazon.co.jp/dp/B0B4NWK21F?ref=myi_title_dp',
    },
};

export default function Comp() {
    const { useRouter, useLang, isMobile } = useGlobal();
    const { t } = useLang('delta2portablepowerstation');
    const { locale } = useRouter();
    const link1 = linkMap[locale]?.link1;
    const link2 = linkMap[locale]?.link2;

    const goAmazon = () => {
        try {
            window?.fbq('track', 'AddToWishlist');
            gtm.push({
                event: 'uaEvent',
                event_name: 'buy_on_amazon',
                product_name: 'DELTA2',
                button_name: t('delta2.amazon'),
            });
        } catch {
        } finally {
            window.open(link1, '_blank');
        }
    };

    const goStore = () => {
        try {
            window?.fbq('track', 'Search');
            gtm.push({
                event: 'uaEvent',
                event_name: 'buy_on_store',
                product_name: 'DELTA2',
                button_name: t('delta2.store'),
            });
        } catch {
        } finally {
            window.open(link2, '_blank');
        }
    };

    return (
        <div
            className={`${css.mallBanner} ${isMobile ? 'mallBanner-h5' : 'mallBanner-pc'} GtmModuleData-section`}
            data-section-id={css.mallBanner}
            data-section-title={t('delta2.title')}
        >
            <div className="banner-img-box">
                {isMobile && (
                    <div className="img-wrapper">
                        <EFPic2 name={['kv.webp', 'kv.jpg']} loading="eager" />
                    </div>
                )}
                {!isMobile && <EFPic1 name={['kv.webp', 'kv.jpg']} loading="eager" />}
            </div>
            <div className="banner-text-box">
                <div className="banner-title2">{t('delta2.title')}</div>
                <div className="banner-title3">{t('delta2.title2')}</div>
            </div>
            <div className="banner-btns">
                {link2 && (
                    <span className="banner-btn banner-btn-2" onClick={goStore}>
                        {t('delta2.store')}
                    </span>
                )}
                {link1 && (
                    <span className="banner-btn banner-btn-1" onClick={goAmazon}>
                        {t('delta2.amazon')}
                    </span>
                )}
            </div>
        </div>
    );
}
